import axios from './$http'
import config from "./$http/apiurl"

// 获取小程序码
export const getMiniCord = (path) => {
  return config.hostUrl + "/wx/getUnlimited?" + path
}